<template>
  <div>
    <Head title="Agenda" />

    <files-modal ref="modalFiles">
    </files-modal>

    <div class="shadow_box rounded-lg p-6">
      <div class="mb-6 flex justify-between">
        <h1 class="text-2xl text-gray-777 font-roboto uppercase">Agenda</h1>
        <button class="flex items-end font-roboto font-medium btn-primary uppercase" @click.prevent="openModalAddAppointment()">
          <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" /><span class="hidden lg:block">Adicionar Atendimento</span>
        </button>
      </div>
      <div class="w-full mb-6">
        <button class="flex items-end font-roboto font-medium btn-primary uppercase" @click.prevent="openModalManageHours()">
          <font-awesome-icon icon="fa-regular fa-clock" class="text-white text-lg mr-2" />Gerenciar horários<span class="hidden lg:block">&nbsp;de atendimento</span>
        </button>
      </div>
      <div class="flex flex-wrap mb-6">
        <div class="w-full lg:w-1/2">
          <div class="bg-primary text-white rounded-lg p-5 lg:mx-2">
            <div class="font-bold text-3xl">{{ totalCompleted }}</div>
            <div class="font-light">Atendimentos já realizados</div>
          </div>
        </div>
        <div class="w-full lg:w-1/2">
          <div class="bg-primary text-white rounded-lg p-5 mt-5 lg:mt-0 lg:mx-2">
            <div class="font-bold text-3xl">{{ totalNotCompleted }}</div>
            <div class="font-light">Atendimentos não realizados</div>
          </div>
        </div>
        <div class="w-full lg:w-1/2">
          <div class="bg-primary text-white rounded-lg p-5 mt-5 lg:mx-2">
            <div class="font-bold text-3xl">{{ totalInProgress }}</div>
            <div class="font-light">Atendimentos em aberto</div>
          </div>
        </div>
        <div class="w-full lg:w-1/2">
          <div class="bg-primary text-white rounded-lg p-5 mt-5 lg:mx-2" v-if="monthYear">
            <div class="font-bold text-3xl">{{ totalMonth }}</div>
            <div class="font-light">Agendamentos no mês</div>
          </div>
        </div>
      </div>

      <data-table
        v-if="loadTable"
        v-model:columns="columns"
        route="schedules/list"
        :query='{ "month": selectedMonthFormatted }'
        no-data-label="Nenhum agendamento cadastrado"
        no-result-label="Nenhum agendamento encontrado"
      >
        <template #table.cell.content.actions="{ value, row }">
          <div class="inline-grid grid-cols-auto gap-4">
            <button
              v-if="row.openRoom && row.type_service !== 'external'"
              class="btn-primary font-normal text-xs px-4 py-2.5" @click="openRoom(row)">Acessar consulta</button>
            <button v-if="row.allowReschedule" class="btn-primary font-normal text-xs px-4 py-2.5" @click="openModalReschedule(row)">Reagendar consulta</button>
            <button v-if="row.allowCancel" class="btn bg-white text-red-700 border border-red-700 font-normal text-xs px-4 py-2.5" @click="openModalCancel(row)">Cancelar consulta</button>
            <div v-if="!row.allowReschedule && !row.allowCancel && !row.openRoom"> </div>

            <button
              v-if="row.patient_files_count != 0"
              class="btn-primary font-normal text-xs px-4 py-2.5 block w-full"
              @click="openModalFiles(row.id, 'files')">
                Ver documentos
                <font-awesome-icon icon="fa-file-arrow-up" class="ml-2" />
            </button>

            <button
              v-if="row.patient_description_count != 0"
              class="btn-primary font-normal text-xs px-4 py-2.5 block w-full"
              @click="openModalFiles(row.id, 'description')">
                Ver Descrições
                <font-awesome-icon icon="fa-clipboard" class="ml-2" />
            </button>
          </div>

        </template>

        <template #grid.content.body.actions="{ value, row }">
          <div class="inline-grid grid-cols-auto gap-4">
            <button  v-if="row.openRoom && row.type_service !== 'external'"
                    class="btn-primary font-normal text-xs px-4 py-2.5" @click="openRoom(row)">Acessar consulta</button>
            <button v-if="row.allowReschedule" class="btn-primary font-normal text-xs px-4 py-2.5" @click="openModalReschedule(row)">Reagendar consulta</button>
            <button v-if="row.allowCancel" class="btn bg-white text-red-700 border border-red-700 font-normal text-xs px-4 py-2.5" @click="openModalCancel(row)">Cancelar consulta</button>
            <div v-if="!row.allowReschedule && !row.allowCancel && !row.openRoom"> </div>

            <button
              v-if="row.patient_files_count != 0"
              class="btn-primary font-normal text-xs px-4 py-2.5 block w-full"
              @click="openModalFiles(row.id, 'files')">
                Ver documentos
                <font-awesome-icon icon="fa-file-arrow-up" class="ml-2" />
            </button>

            <button
              v-if="row.patient_description_count != 0"
              class="btn-primary font-normal text-xs px-4 py-2.5 block w-full"
              @click="openModalFiles(row.id, 'description')">
                Ver Descrições
                <font-awesome-icon icon="fa-clipboard" class="ml-2" />
            </button>
          </div>

        </template>

        <template #after.reload-button>
          <DateMonthInput class="w-full" placeholder="Mês" v-model="selectedDate" />
        </template>

        <template #table.cell.content.date_end="{ value, row }">
          <template v-if="row.type_service != 'telemedicine'">{{ value }}</template>
          <template v-else>
            <popover class="mr-8 md:mr-0" placement="bottom-end">
              <template #default>
                <span class="text-primary font-semibold cursor-pointer">
                  {{ value }}
                </span>
              </template>
              <template #dropdown>
                <div class="p-4 bg-white shadow_box rounded-lg text-xs">
                  <div class="grid gap-4 grid-cols-3">
                    <div></div>
                    <div>Entrada</div>
                    <div>Saída</div>
                    <div>Profissional</div>
                    <div>
                      {{ row.professional_date_join ? row.professional_date_join.substr(10, 6) : '-' }}
                    </div>
                    <div>
                      {{ row.professional_date_out ? row.professional_date_out.substr(10, 6) : '-' }}
                    </div>
                    <div>Paciente</div>
                    <div>
                      {{ row.patient_date_join ? row.patient_date_join.substr(10, 6) : '-' }}
                    </div>
                    <div>
                      {{ row.patient_date_out ? row.patient_date_out.substr(10, 6) : '-' }}
                    </div>
                  </div>
                </div>
              </template>
            </popover>
          </template>
        </template>

        <template #table.content.body.date_end="{ value, row }">
          <template v-if="row.type_service != 'telemedicine'">{{ value }}</template>
          <template v-else>
            <popover class="mr-8 md:mr-0" placement="bottom-end">
              <template #default>
                <span class="text-primary font-semibold cursor-pointer">
                  {{ value }}
                </span>
              </template>
              <template #dropdown>
                <div class="p-4 bg-white shadow_box rounded-lg text-xs">
                  <div class="grid gap-4 grid-cols-3">
                    <div></div>
                    <div>Entrada</div>
                    <div>Saída</div>
                    <div>Profissional</div>
                    <div>
                      {{ row.professional_date_join ? row.professional_date_join.substr(10, 6) : '-' }}
                    </div>
                    <div>
                      {{ row.professional_date_out ? row.professional_date_out.substr(10, 6) : '-' }}
                    </div>
                    <div>Paciente</div>
                    <div>
                      {{ row.patient_date_join ? row.patient_date_join.substr(10, 6) : '-' }}
                    </div>
                    <div>
                      {{ row.patient_date_out ? row.patient_date_out.substr(10, 6) : '-' }}
                    </div>
                  </div>
                </div>
              </template>
            </popover>
          </template>
        </template>

      </data-table>
    </div>

    <modal-edit ref="modalManageHours" title="Agenda" url="schedules" @submitForm="updateManageHours" :modal-scrollable="true">
      <template #header="{item}">
        <div class="text-gray-777 font-roboto uppercase">
          Editar Agenda
        </div>
      </template>
      <template #form="{item}">
        <date-input
          info="Aqui você deve escolher a data de início da sua agenda, selecione uma data no futuro. Você pode escolher qualquer data a partir de hoje."
          v-model="item.date_start"
          :error="item.errors.date_start"
          class="lg:pr-6 w-full lg:w-3/12"
          label="Data inicial" />

        <date-input
          info="Aqui você deve escolher a data final da sua agenda, selecione uma data no futuro que seja posterior à data de início. Você pode escolher qualquer data a partir da data inicial selecionada."
          v-model="item.date_end"
          :error="item.errors.date_end"
          class="lg:pr-6 mt-6 lg:mt-0 w-full lg:w-3/12"
          label="Data final" />

        <time-picker info="Este campo permite que você defina a duração de cada consulta em horas. Isso é importante para que a sua agenda seja criada com os intervalos corretos de tempo. Lembre-se de escolher um tempo que seja realista e que permita que você atenda aos seus pacientes de forma eficiente." v-model="item.attendance_time" :error="item.errors.attendance_time" class="mt-6 lg:mt-0 w-full lg:w-6/12" label="Duração do atendimento (horas)" />

        <div class="mt-6 w-full flex flex-nowrap justify-between">
          <button class="text-xs flex items-center font-roboto font-medium btn-primary uppercase" @click.prevent="item.schedules.push({day_of_week: null});">
            <font-awesome-icon icon="fa-plus" class="text-white text-xs mr-0 lg:mr-2" /> Adicionar Horário
          </button>
          <popover placement="bottom-end">
            <template #default>
              <font-awesome-icon icon="fa-circle-info" class="text-gray-600 cursor-pointer" />
            </template>
            <template #dropdown>
              <div class="bg-primary text-white text-sm p-4 max-w-[250px] max-h-[300px] shadow-lg overflow-x-hidden overflow-y-scroll scrollbar-thin scrollbar-thumb-blue-900 scrollbar-track-gray-200">
                Neste campo, você pode selecionar os dias e os horários em que deseja disponibilizar sua agenda de atendimentos. É importante lembrar que você também deve estar atento aos horários em que não atende, como o horário do almoço, por exemplo. Para isso, selecione o dia e o horário de início do seu expediente até o horário do intervalo. Em seguida, adicione um novo horário com o mesmo dia da semana selecionado, mas com o horário inicial a partir do término do intervalo e o horário final até o encerramento dos atendimentos. Certifique-se de que os horários escolhidos sejam adequados para o tipo de atendimento que você realiza e que permitam que você atenda aos seus pacientes de forma adequada. Se precisar bloquear algum dia ou horário específico, utilize o botão "Adicionar Exceção" para isso.
              </div>
            </template>
          </popover>
        </div>

        <div v-if="item.errors.schedules" class="w-full mt-4 form-error">
          {{ item.errors.schedules }}
        </div>
        <div class="w-full flex flex-wrap p-6 mt-4 bg-gray-100/50 relative" v-for="(schedule, schedule_index) in item.schedules">
          <select-input v-model="schedule.day_of_week" :error="item.errors[`schedules.`+schedule_index+`.day_of_week`]" class="mt-4 lg:mt-0 lg:pr-6 w-full lg:w-4/12" placeholder="Dia">
            <option :value="null" disabled class="hidden invisible">Dia</option>
            <option v-for="(value, name, index) in this.schedule_days_of_week" :key="name" :value="name">{{ value }}</option>
          </select-input>
          <time-picker v-model="schedule.time_start" :error="item.errors[`schedules.`+schedule_index+`.time_start`]" class="mt-4 lg:mt-0 lg:pr-6 w-full lg:w-3/12" placeholder="Início" />
          <time-picker v-model="schedule.time_end" :error="item.errors[`schedules.`+schedule_index+`.time_end`]" class="mt-4 lg:mt-0 lg:pr-6 w-full lg:w-3/12" placeholder="Final" />
          <div class="mt-6 lg:mt-0 w-full lg:w-2/12">
            <button class="text-xs flex items-center font-roboto font-medium btn-primary uppercase" @click.prevent="cloneSchedule(item, schedule);">
              Duplicar
            </button>
          </div>
          <div class="absolute top-2 right-2">
            <span @click="deleteSchedule(item, schedule)"><font-awesome-icon icon="fa-xmark" class="text-gray-600 text-lg cursor-pointer" /></span>
          </div>
        </div>

        <div class="w-full mt-3"></div>

        <div class="mt-6 w-full flex flex-nowrap justify-between">
          <button class="text-xs mt-6 flex items-center font-roboto font-medium btn-primary uppercase" @click.prevent="item.schedule_exceptions.push({});">
            <font-awesome-icon icon="fa-plus" class="text-white text-xs mr-0 lg:mr-2" /> Adicionar Exceção
          </button>
            <popover placement="bottom-end">
              <template #default>
              <font-awesome-icon icon="fa-circle-info" class="text-gray-600 cursor-pointer" />
            </template>
            <template #dropdown>
              <div class="bg-primary text-white text-sm p-4 max-w-[250px] max-h-[300px] shadow-lg overflow-x-hidden overflow-y-scroll scrollbar-thin scrollbar-thumb-blue-900 scrollbar-track-gray-200">
                Aqui você cadastra os dias e/ou horários específicos que você bloqueará sua agenda, deixando-a indisponível para atendimento. Por exemplo, se você tiver compromissos marcados para datas que coincidem com sua agenda de atendimentos, você pode bloquear dias e/ou horários específicos.
              </div>
            </template>
          </popover>
        </div>
        <div class="w-full flex flex-wrap p-6 mt-4 bg-gray-100/50" v-for="(schedule_exception, schedule_exception_index) in item.schedule_exceptions">
          <date-time-input v-model="schedule_exception.date_start" :error="item.errors[`schedule_exceptions.`+schedule_exception_index+`.date_start`]" class="mt-4 lg:mt-0 lg:pr-6 w-full lg:w-1/2" placeholder="Início" />
          <date-time-input v-model="schedule_exception.date_end" :error="item.errors[`schedule_exceptions.`+schedule_exception_index+`.date_end`]" class="mt-4 lg:mt-0 w-5/6 lg:w-5/12" placeholder="Final" />
          <div class="mt-6 lg:mt-0 w-1/6 lg:w-1/12 self-center text-right">
            <span @click="deleteScheduleException(item, schedule_exception)"><font-awesome-icon icon="fa-xmark" class="text-gray-600 text-lg cursor-pointer" /></span>
          </div>
        </div>

      </template>
    </modal-edit>
    <modal-reschedule ref="modalReschedule" @confirm="updateAddAppointment"></modal-reschedule>
    <modal-cancel ref="modalCancel" @confirm="updateAddAppointment"></modal-cancel>
    <modal-edit ref="modalAddAppointment" title="Atendimento" url="appointments" @submitForm="updateAddAppointment" :modal-scrollable="true">
      <template #form="{item}">
        <text-input v-model="item.patient_name" :error="item.errors.patient_name" class="w-full lg:w-1/2 lg:pr-6" label="Nome do paciente" />
        <email-input v-model="item.patient_email" :error="item.errors.patient_email" class="w-full lg:w-1/2 mt-6 lg:mt-0" label="E-mail do paciente (opcional)" />
        <phone-input v-model="item.patient_phone" :error="item.errors.patient_phone" class="w-full lg:w-1/2 mt-6 lg:pr-6" label="Telefone do paciente (opcional)" />
        <select-input v-model="item.specialty" :error="item.errors.specialty" class="pb-8 w-full lg:w-1/2 mt-6" label="Especialidade">
          <option :value="null" />
          <option v-for="(value, name) in this.specialties" :key="value.name" :value="value.id">{{ value.name }}</option>
        </select-input>
        <div class="w-full lg:w-1/2 lg:pr-6">
          <div class="mb-3">Data do atendimento:</div>
          <calendar v-if="this.loadAllowedDates" v-model="newAppointmentDate" :allowedDates="allowedDates" />
          <div v-else class="text-gray-500 text-sm">Aguarde, carregando datas disponíveis</div>
        </div>
        <div class="w-full lg:w-1/2 lg:pr-6">
          <div class="mb-3">Hora do atendimento:</div>
          <div v-if="item.errors.date_start" class="form-error">{{ item.errors.date_start }}</div>
          <div v-if="this.avaliableTimes" class="grid grid-flow-row-dense grid-cols-3 gap-2">
<!--            <div v-for="(times, index) in this.avaliableTimes" @click="this.selectNewAppointmentDate(item, times)" class="cursor-pointer border text-sm text-center py-2" :class="{'bg-gray-300': this.newAppointmentDateSelected(item, times)}">{{ this.$filters.formatDateTime(times.time_start, 'HH:mm') }} - {{ this.$filters.formatDateTime(times.time_end, 'HH:mm') }}-->
<!--            </div>-->
            <div
              v-for="(times, index) in this.avaliableTimes"
              @click="this.selectNewAppointmentDate(item, times)"
              class="cursor-pointer border text-sm text-center py-2"
              :class="{ 'bg-gray-300': this.newAppointmentDateSelected(item, times) }"
            >
              {{ this.$filters.formatDateTime(times.time_start, 'HH:mm') }} - {{ this.$filters.formatDateTime(times.time_end, 'HH:mm') }}
            </div>

          </div>
          <div v-else-if="this.newAppointmentDate" class="text-gray-500 text-sm">Aguarde, carregando horários disponíveis</div>
          <div v-else class="text-gray-500 text-sm">Selecione uma data para o atendimento</div>
        </div>
      </template>
    </modal-edit>
    <modal ref="modalConfirm" :modal-backdrop="true">
        <template #body>
          <div class="mb-6">
            <div class="mb-6">
              <span v-if="user.professional.sex == 'm'">Prezado</span>
              <span v-else-if="user.professional.sex == 'f'">Prezada</span>
              <span v-else>Prezado(a)</span>
              {{ user.name }},
            </div>
            <div class="mb-4">
              Obrigado por cadastrar sua agenda na ah.life! Informamos as formas de recebimento:
            </div>
            <div class="indent-8 mb-2">PIX: Após atendimento com paciente.</div>
            <div class="indent-8 mb-4">Cartão de crédito: Recebimento em 30 dias após o pagamento do paciente, desde que o atendimento tenha sido realizado dentro desse período.</div>
            <div class="mb-6">
              Políticas da Asaas prezam pela segurança e eficiência das transações em nossa plataforma.
            </div>
            <div>
              Dúvidas? Entre em contato pelo suporte. Agradecemos sua parceria!
            </div>
          </div>
          <div class="flex justify-end">
            <button type="button" class="btn-primary font-normal ml-1" @click.prevent="$refs.modalConfirm.showModal = false; firstSchedule = false;">Ok</button>
          </div>
        </template>
    </modal>
    <modal-update-photo-profile ref="modalUpdatePhotoProfile" />

  </div>
</template>

<script>
import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import format from 'date-fns/format';

import Layout from '@/Shared/Layout/Layout'
import DataTable from '@/Shared/Components/DataTable'
import DateMonthInput from '@/Shared/Fields/DateMonthInput'
import ModalEdit from '@/Shared/Modal/ModalEdit'
import DateInput from '@/Shared/Fields/DateInput'
import TimeInput from '@/Shared/Fields/TimeInput'
import SelectInput from '@/Shared/Fields/SelectInput'
import DateTimeInput from '@/Shared/Fields/DateTimeInput'
import ModalReschedule from '@/Shared/Modal/ModalReschedule'
import ModalCancel from '@/Shared/Modal/ModalCancel'
import TextInput from '@/Shared/Fields/TextInput'
import EmailInput from '@/Shared/Fields/EmailInput'
import PhoneInput from '@/Shared/Fields/PhoneInput'
import Calendar from '@/Shared/Components/Calendar'
import Popover from '@/Shared/Components/Popover'
import Modal from '@/Shared/Modal/Modal'
import FilesModal from '@/Shared/Modal/FilesModal'
import ModalUpdatePhotoProfile from '@/Shared/Modal/ModalUpdatePhotoProfile'
import TimePicker from '@/Shared/Fields/TimePicker';



export default {

  props: {
    specialties: Array,
    schedule_days_of_week: {},
    schedule: {},
    totalMonth: 0,
    totalCompleted: 0,
    totalNotCompleted: 0,
    totalInProgress: 0,
  },
  components: {
    Head,
    Link,
    DataTable,
    format,
    DateMonthInput,
    ModalEdit,
    DateInput,
    TimeInput,
    SelectInput,
    DateTimeInput,
    ModalReschedule,
    ModalCancel,
    TextInput,
    EmailInput,
    PhoneInput,
    Calendar,
    Popover,
    Modal,
    FilesModal,
    ModalUpdatePhotoProfile,
    TimePicker,
  },
  layout: Layout,
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
  watch: {
    selectedDate(selectedDateNew, selectedDateOld) {
      this.monthYear = null;
      if(selectedDateNew != null) {
        this.monthYear = selectedDateNew.substr(0, 4) + '-' + selectedDateNew.substr(5, 2);
      }
      this.reloadTable();
      this.updateTotals();
    },
    newAppointmentDate(newAppointmentDateNew, newAppointmentDateOld) {
      this.avaliableTimes = null;
      this.selectedTimeBlocks = [];
      this.$refs.modalAddAppointment.item.date_start = null;
      this.$refs.modalAddAppointment.item.date_end = null;
      if(this.newAppointmentDate instanceof Date) {
        let date = this.newAppointmentDate.getFullYear() + '-' + (this.newAppointmentDate.getMonth() + 1).toString().padStart(2, '0') + '-' + this.newAppointmentDate.getDate().toString().padStart(2, '0');
        this.loadAvaliableTimes(date);
      }
    },
  },
  computed: {
    selectedMonthFormatted: function() {
      return this.monthYear ? this.monthYear : (this.selectedDate ? format(this.selectedDate, 'yyyy-MM') : '');
    },
  },
  mounted() {
    this.loadOptions();
    if(this.schedule.date_start) {
      this.firstSchedule = false;
    }

    if(this.user.professional){
      if(!this.user.photo) {
        this.$refs.modalUpdatePhotoProfile.openModalUpdatePhotoProfile();
      }
    }

  },
  data() {
    return {
      firstSchedule: true,
      loadAllowedDates: false,
      allowedDates: [],
      avaliableTimes: null,
      monthYear: (new Date()).getFullYear() + '-' + ((new Date()).getMonth() + 1).toString().padStart(2, '0'),
      newAppointmentDate: null,
      selectedDate: (new Date()).getFullYear() + '-' + ((new Date()).getMonth() + 1).toString().padStart(2, '0'),
      loadTable: true,
      selectedTimeBlocks: [],
      columns: [
        {
          uniqid: 'patient_name',
          label: 'Paciente',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          // format: (val, row) => row.patient?.user?.name ?? '',
          format: (val, row) => {
            //validação para exibir o nome do paciente agendado pelo profissional
            if (row.patient?.user?.name) {
              return row.patient.user.name;
            }
            return row.patient_name ?? '';
          },

        },
        {
          uniqid: 'date_start',
          label: 'Data da Consulta',
          field: 'date_start',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => this.$filters.formatDate(row.date_start ?? ''),
        },
        {
          uniqid: 'date_end',
          label: 'Horário',
          field: 'date_end',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => {
            const start = row.date_start ?? '';
            const end = row.date_end ?? '';
            return start.substr(10, 6) + ' - ' + end.substr(10, 6);
          },
        },
        {
          uniqid: 'is_return',
          label: 'Retorno',
          visible: this.patient?.b2b === false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.is_return ?? '',
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
      ],

    }
  },
  methods: {
    deleteSchedule(form, schedule) {
      form.schedules.splice(form.schedules.indexOf(schedule), 1);
    },
    cloneSchedule(form, s) {
      let schedule = {
        day_of_week: s.day_of_week,
        time_start: s.time_start,
        time_end: s.time_end,
      };
      form.schedules.push(schedule);
    },
    deleteScheduleException(form, schedule_exception) {
      form.schedule_exceptions.splice(form.schedule_exceptions.indexOf(schedule_exception), 1);
    },
    openModalManageHours() {
      this.$refs.modalManageHours.openModalEdit(this.schedule);
    },
    updateManageHours() {
      if(this.firstSchedule) {
        this.$refs.modalConfirm.showModal = true;
      }
      this.loadOptions();
    },

    openModalFiles(appointment_id, filter) {
      this.$refs.modalFiles.openModal(appointment_id, filter)
    },

    openModalAddAppointment() {
      this.avaliableTimes = null;
      this.newAppointmentDate = null;
      this.$refs.modalAddAppointment.openModalEdit({
        patient_name: '',
        patient_email: '',
        patient_phone: '',
        specialty: '',
        date_start: null,
        date_end: null,
      });
    },
    updateAddAppointment() {
      this.reloadTable();
      this.loadOptions();
      this.updateTotals();
    },
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    },
    updateTotals() {
      this.$inertia.reload({
        method: 'put',
        only: [
          'flash',
          'totalMonth',
          'totalInProgress',
          'totalCompleted',
          'totalNotCompleted',
        ],
        data: {
          month: this.monthYear,
        }
      });
    },
    openRoom(item) {
      this.$inertia.visit(`/patients/detail/${item.patient.id}/${item.id}`);
    },
    openModalReschedule(item) {
      this.$refs.modalReschedule.openModalReschedule(item, `/appointments/reschedule/${item.id}`);
    },
    openModalCancel(item) {
      this.$refs.modalCancel.openModalCancel(item, `/appointments/cancel/${item.id}`);
    },
    async loadOptions() {
      await fetch(
        `schedules/get-options`
      ).then(res => {
        res.json().then(json => {
          this.allowedDates = json.allowedDates;
          this.loadAllowedDates = true;
        });
      });
    },
    async loadAvaliableTimes(date) {
      await fetch(
        `/schedules/get-avaliable-times/` + date
      ).then(res => {
        res.json().then(json => {
          this.avaliableTimes = json;
        });
      });
    },
    selectNewAppointmentDate(item, selected) {
      const isSameBlock = (a, b) => a.time_start === b.time_start && a.time_end === b.time_end;
      const alreadySelected = this.selectedTimeBlocks.find(b => isSameBlock(b, selected));
      if (alreadySelected) {
        this.selectedTimeBlocks = this.selectedTimeBlocks.filter(b => !isSameBlock(b, selected));
        this.updateDateRange(item);
        return;
      }

      if (this.selectedTimeBlocks.length === 0) {
        this.selectedTimeBlocks.push(selected);
        this.updateDateRange(item);
        return;
      }
      const sorted = [...this.selectedTimeBlocks, selected].sort(
        (a, b) => a.time_start.localeCompare(b.time_start)
      );

      const isSequential = sorted.every((block, i, arr) => {
        if (i === arr.length - 1) return true;
        const currentEnd = new Date(block.time_end);
        const nextStart = new Date(arr[i + 1].time_start);
        return currentEnd.getTime() === nextStart.getTime();
      });

      if (!isSequential) {
        this.$toast.warning("Só é permitido selecionar horários sequenciais.");
        return;
      }

      this.selectedTimeBlocks = sorted;
      this.updateDateRange(item);
    },
    updateDateRange(item) {
      const blocks = this.selectedTimeBlocks;

      if (blocks.length === 0) {
        item.date_start = null;
        item.date_end = null;
        return;
      }

      item.date_start = blocks[0].time_start;
      item.date_end = blocks[blocks.length - 1].time_end;
    },
    newAppointmentDateSelected(item, times) {
      return this.selectedTimeBlocks.some(
        b => b.time_start === times.time_start
      );
    },
    openModalUpdatePhotoProfile() {
      this.$refs.modalUpdatePhotoProfile.openModalUpdatePhotoProfile();
    },
    // selectNewAppointmentDate(item, times) {
    //   item.date_start = times.time_start;
    //   item.date_end = times.time_end;
    // },
    // newAppointmentDateSelected(item, times) {
    //   return item.date_start == times.time_start && item.date_end == times.time_end;
    // },

  },
}
</script>
